<template>
  <sidebar-layout>
    <!-- This anchor is used on mobile by an in-page link to jump to the RSVP form. -->
    <a v-if="renderFormAnchor" name="attendee-form" />
    <h2>{{ i18n.t('events.show.attend_title') }}</h2>
    <one-click-info />
    <div class="attend-event-form">
      <rsvp-form :attending-status="attendingStatus" />
    </div>
  </sidebar-layout>
</template>

<script>
import { ATTENDING } from './attending-statuses'
import OneClickInfo from './one-click-info'
import RsvpForm from './form'
import SidebarLayout from '@/campaign-action-shared/sidebar-layout'

export default {
  components: { OneClickInfo, RsvpForm, SidebarLayout },

  props: {
    renderFormAnchor: {
      type: Boolean,
      required: false,
      default: true
    }
  },

  data() {
    return {
      attendingStatus: ATTENDING
    }
  }
}
</script>
